<template>
    <div style="height: 100%">
        <RelatorioFaturamentoList v-show="!rotaAninhada" :reloadData="reloadData" />
        <router-view />
    </div>
</template>

<script>
import RelatorioFaturamentoList from '@/components/promotor/relatorio-analitico/relatorio-faturamento/RelatorioFaturamentoList.vue';

export default {
    name: 'RelatorioFaturamentoListRoute',

    beforeRouteUpdate(to, from, next) {
        this.rotaAninhada = to.name != 'relatorio-faturamento-list';
        if (from.name != 'relatorio-faturamento-list' && to.name == 'relatorio-faturamento-list') {
            this.reloadData = true;
            setTimeout(() => (this.reloadData = false), 300);
        }
        next();
    },
    components: {
        RelatorioFaturamentoList,
    },
    data() {
        return {
            rotaAninhada: false,
            reloadData: false,
        };
    },
    created() {
        this.rotaAninhada =
            this.$route.name.includes('relatorio-faturamento') &&
            this.$route.name != 'relatorio-faturamento-list';
    },
};
</script>
